import { Controller } from "@hotwired/stimulus"

// Generic controller for status change dropdown menus
// Used for goals, projects, and other entities with status transitions
export default class extends Controller {
  static targets = ["menu"]

  toggle(event) {
    event.stopPropagation()
    this.menuTarget.classList.toggle("hidden")

    // Close when clicking outside
    if (!this.menuTarget.classList.contains("hidden")) {
      this.boundClose = this.closeOnClickOutside.bind(this)
      document.addEventListener("click", this.boundClose)
    }
  }

  close() {
    this.menuTarget.classList.add("hidden")
    if (this.boundClose) {
      document.removeEventListener("click", this.boundClose)
    }
  }

  closeOnClickOutside(event) {
    if (!this.element.contains(event.target)) {
      this.close()
    }
  }

  disconnect() {
    if (this.boundClose) {
      document.removeEventListener("click", this.boundClose)
    }
  }
}
